const Stickyfill = require('stickyfilljs')

$(() => {
  Stickyfill.add($('.sticky'))
})
